module.exports = __webpack_public_path__ + "static/minnesota-affordable-home-improvement-company-c4c33fde6854e32645c502e82b4f52da.svg";